(() => {
  const STORAGE_KEY = 'bsa-intro-seen';

  function initializeIntro() {
    const intro = document.getElementById('bsa-dynamic-intro');
    if (!intro) return;

    const root = document.documentElement;
    const oncePerSession = intro.dataset.oncePerSession === 'true';
    let alreadySeen = root.classList.contains('bsa-intro-seen');

    try {
      alreadySeen = alreadySeen || (oncePerSession && sessionStorage.getItem(STORAGE_KEY) === '1');
    } catch (error) {}

    if (alreadySeen) {
      intro.remove();
      return;
    }

    document.body.classList.add('bsa-intro-active');
    if (oncePerSession) {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (error) {}
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const configuredDuration = Number.parseInt(intro.dataset.duration || '3000', 10);
    const duration = reducedMotion ? 650 : Math.max(2000, Math.min(configuredDuration, 5000));
    const skipButton = intro.querySelector('.bsa-intro__skip');
    let closed = false;

    function handleKeydown(event) {
      if (event.key === 'Escape') closeIntro();
    }

    function closeIntro() {
      if (closed) return;
      closed = true;
      intro.classList.add('is-closing');
      document.body.classList.remove('bsa-intro-active');
      document.removeEventListener('keydown', handleKeydown);
      window.setTimeout(() => intro.remove(), reducedMotion ? 220 : 680);
    }

    skipButton?.addEventListener('click', closeIntro);
    document.addEventListener('keydown', handleKeydown);
    window.setTimeout(closeIntro, duration);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeIntro, { once: true });
  } else {
    initializeIntro();
  }
})();
